import { BaseModel, ImageModel } from './base.model';

export class BannerModel extends BaseModel {
  name: string;
  title: string;
  description: string;
  image: ImageModel;
  position: number;

  constructor(obj: any = null) {
    super(obj);
    this.name = obj?.name;
    this.title = obj?.title;
    this.description = obj?.description;
    this.image = new ImageModel(obj?.image);
    this.position = obj?.position;
  }
}

export class BannerRequestModel {
  name: string;
  title: string;
  description: string;
  image_id: string;
  position: number;

  constructor(obj: any = null) {
    this.name = obj?.name;
    this.title = obj?.title;
    this.description = obj?.description;
    this.image_id = obj?.image_id;
    this.position = obj?.position;
  }
}
